import {
  admin_cse,
  provider_behavioral,
  provider_case_manager,
  provider_pcp,
  provider_prescribe,
} from "@/config/roles";
import type { Note } from "@/core/types";

import { isAuthorizedToViewFullNote } from "./isAuthorizedToViewFullNote";

const SESSION_HISTORY_ROLES: string[] = [
  admin_cse,
  provider_behavioral,
  provider_case_manager,
  provider_pcp,
  provider_prescribe,
];

// Mirrors the roles allowed by GET /v1/cosignature/note/{noteId}/history
export function isAuthorizedToViewCosignHistory(note: Note, role: string | false): boolean {
  return (
    role !== false && SESSION_HISTORY_ROLES.includes(role) && isAuthorizedToViewFullNote(note, role)
  );
}
